/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions';
export function FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesFromJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesToJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreCreatePaymentRequestCrazyGames.js.map